import React, { SyntheticEvent } from "react"
import { useTranslation } from "react-i18next";

//MUI
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";

// Custom
import InfoPaneActionButton from "./InfoPaneActionButton";

type InfoPanePDFActionButtonProps = {
  onClick: (evt: SyntheticEvent) => void;
}

const InfoPanePDFActionButton = (props: InfoPanePDFActionButtonProps) => {

  const { onClick } = props;

  return (
    <InfoPaneActionButton
      icon={
        <MapOutlinedIcon
          sx={{ transform: "scale(0.8)" }}
          color="primary" fontSize="large"
        />
      }
      onClick={onClick}
      title_ttoken="map:route.buttons.download_pdf"
    />
  );
}

export default InfoPanePDFActionButton;
